module.exports = __webpack_public_path__ + "img/2025_ShortSleeve.4dfc7d9d.jpg";